import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const columns = [
  { titleKey: 'pourquoi_1_title', descKey: 'pourquoi_1_desc', icon: 'ri-wallet-3-line' },
  { titleKey: 'pourquoi_2_title', descKey: 'pourquoi_2_desc', icon: 'ri-palette-line' },
  { titleKey: 'pourquoi_3_title', descKey: 'pourquoi_3_desc', icon: 'ri-time-line' },
];

export default function PourquoiLeBardeau() {
  const { t } = useTranslation('bardeau');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="pourquoi" className="bg-white py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl">
            {t('pourquoi_h2')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6">
          {columns.map((col, idx) => (
            <div
              key={idx}
              className={`bg-soft-gray rounded-xl p-6 md:p-8 text-center transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${idx * 150 + 200}ms` }}
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-copper/10 mx-auto mb-5">
                <i className={`${col.icon} text-copper text-2xl`} />
              </div>
              <h3 className="font-manrope font-bold text-slate-primary text-sm md:text-base tracking-wide mb-3">
                {t(col.titleKey)}
              </h3>
              <p className="text-slate-primary/60 text-sm leading-relaxed">
                {t(col.descKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}